import React from "react"
import Button from "@components/button"
import Grid from "@components/grid"
import styles from "./styles.module.scss"

// ---------------------------------------------------------

const ChuckPricing = () => {
  return (
    <Grid
      width="narrow"
      className={styles.quote}
      column={2}
      backgroundColor="off-black"
      header="Pricing"
    >
      <div className={styles.gradient_wrap}>
        <div className={styles.pricing_container}>
          <h4>Free tier</h4>
          <ul>
            <li className={styles.avail}>Databricks native CLI</li>
            <li className={styles.avail}>Unity Catalog integration</li>
            <li className={styles.avail}>Basic data exploration</li>
            <li className={styles.avail}>PII detection</li>
            <li className={styles.avail}>Semantic tagging framework</li>
            <li className={styles.avail}>Customer-centric data modeling</li>
            <li className={styles.avail}>Identity graph</li>
            <li className={styles.not_avail}>Stable ID algorithm</li>
            <li className={styles.not_avail}>Advanced security features</li>
            <li className={styles.not_avail}>Technical support</li>
          </ul>
          <Button
            className={styles.pricing_button}
            theme="prime-teal"
            url="https://chuck.amperity.com"
          >
            Get started for free
          </Button>
        </div>
      </div>
      <div className={styles.pricing_container}>
        <h4>Enterprise tier</h4>
        <p className={styles.coming_soon_label}>
          <em>Included during research preview</em>
        </p>
        <ul>
          <li className={styles.avail}>All features of the free tier</li>
          <li className={styles.avail}>Unlimited Stitch records</li>
          <li className={styles.avail}>Technical support</li>
          <li className={styles.coming_soon}>Stable ID algorithm (coming soon)</li>
          <li className={styles.coming_soon}>Advanced security features (coming soon)</li>
        </ul>
      </div>
    </Grid>
  )
}
export default ChuckPricing
